import noop from 'utils/noop';

export const initializeMenuPerformanceMonitors = noop;
